module.exports = __webpack_public_path__ + "img/json.14911d83.svg";